import style from "./Printer.module.css";
import logo from "../../../assets/images/logo-hacom-2024.png";
import logoDVT from "../../../assets/images/logoDVT.svg";
import { IconCheckbox, IconSquare } from "@tabler/icons-react";

const GoodsReceiptInspectionRecord = ({
  innerRef,
  dataPrint,
  dataPYCXL,
  viewPrint,
}: {
  innerRef: any;
  dataPrint: any;
  dataPYCXL?: any;
  viewPrint: string;
}) => {
  const listDataItemPNHL = dataPrint?.tblWarrantyReceiveTicketDetailModels?.map(
    (item: any) => String(item?.serial).trim(),
  );

  const listDataViewPNHL: any[] =
    dataPYCXL?.tblWarrantyServiceRequestFormDetailModels?.filter((item: any) =>
      listDataItemPNHL.includes(String(item?.serial).trim()),
    );

  return (
    <div ref={innerRef} className={style.main}>
      <div
        className={
          dataPrint?.companyCode === "DVT"
            ? `${style.header} ${style.bdRed}`
            : `${style.header}`
        }
      >
        <img
          className={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? `${style.customImg}` : ""
          }
          src={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? logoDVT : logo
          }
          alt={dataPrint?.companyCode === "DVT" ? "logoDVT" : "logo Hacom"}
          width={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 175 : 150
          }
          height={
            // dataPrint?.branchId === 222 || dataPrint?.branchId === 223
            dataPrint?.companyCode === "DVT" ? 50 : "auto"
          }
          style={{
            objectFit: "contain",
          }}
        />

        <div>
          <div
            className={
              dataPrint?.companyCode === "DVT" ? style.line : style.lineGRIR
            }
          >
            <h3>
              {" "}
              {dataPrint?.companyCode === "DVT"
                ? "CÔNG TY CỔ PHẦN HACOM DỊCH VỤ TỐT"
                : "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM"}
            </h3>
          </div>
          <div
            className={
              dataPrint?.companyCode === "DVT" ? style.line : style.lineGRIR
            }
          >
            <p className={style.cText}>Trụ sở: </p>
            <p>129+131 Lê Thanh Nghị, P.Bạch Mai, TP.Hà Nội</p>
          </div>
          <div
            className={
              dataPrint?.companyCode === "DVT" ? style.line : style.lineGRIR
            }
          >
            <p className={style.cText}>VPGD: </p>
            <p>
              Tầng 3 Tòa nhà LILAMA, số 124 Minh Khai, P.Tương Mai, TP.Hà Nội
            </p>
          </div>
          <div
            className={
              dataPrint?.companyCode === "DVT" ? style.line : style.lineGRIR
            }
          >
            <div>
              <p className={style.cText}>Tel: </p>
              <p>
                {dataPrint?.companyCode === "DVT" ? "1800 8091" : "1900 1903"}
              </p>
            </div>
            <div>
              <p className={style.cText}>Email: </p>
              <p>info@hacom.vn</p>
            </div>
            <div>
              <p className={style.cText}>Website: </p>
              <p>
                {dataPrint?.companyCode === "DVT" ? "dichvutot.vn" : "hacom.vn"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={style.body}>
        <div className={style.title}>
          <h2>BIÊN BẢN KIỂM TRA TIẾP NHẬN SẢN PHẨM</h2>
          <p
            style={{
              fontStyle: "italic",
              marginTop: "-20px",
            }}
          >
            (Áp dụng với Sản phẩm có chứa dữ liệu, phần mềm, cài đặt)
          </p>
        </div>
        <div className={style.info}>
          <p className={style.fw}>I. Thông tin phiếu</p>
          {viewPrint === "PYCXL" && (
            <>
              <div className={style.infoForm}>
                <div>
                  <div>
                    <p>Mã phiếu tiếp nhận yêu cầu:</p>
                    <p>{dataPrint?.requestNum}</p>
                  </div>
                  <div>
                    <p>Nhân viên tiếp nhận:</p>
                    <p>{dataPrint?.createByName}</p>
                  </div>
                  <div>
                    <p>Bộ phận/Phòng ban:</p>
                    <p>{dataPrint?.depname}</p>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Ngày tiếp nhận:</p>
                    <p>
                      {" "}
                      {String(
                        new Date(dataPrint?.createDate).getDate(),
                      ).padStart(2, "0")}
                      /
                      {String(
                        new Date(dataPrint?.createDate).getMonth() + 1,
                      ).padStart(2, "0")}
                      /{new Date(dataPrint?.createDate).getFullYear()}{" "}
                      {String(
                        new Date(dataPrint?.createDate).getHours(),
                      ).padStart(2, "0")}
                      :
                      {String(
                        new Date(dataPrint?.createDate).getMinutes(),
                      ).padStart(2, "0")}
                    </p>
                  </div>
                  <div>
                    <p>Chức danh:</p>
                    <p>{dataPrint?.rolename}</p>
                  </div>
                  <div>
                    <p>Chi nhánh xử lý yêu cầu:</p>
                    <p>{dataPrint?.nameBranch}</p>
                  </div>
                </div>
              </div>
              <div className={style.mainProcessingMethod}>
                <p className={style.processingMethod}>Hình thức xử lý:</p>
                <div>
                  {dataPrint?.processingMethod === "XLTX" ? (
                    <IconCheckbox size={14} />
                  ) : (
                    <IconSquare size={14} />
                  )}
                  <p>Xử lý từ xa</p>
                </div>
                <div>
                  {dataPrint?.processingMethod === "XLCN" ? (
                    <IconCheckbox size={14} />
                  ) : (
                    <IconSquare size={14} />
                  )}
                  <p>Xử lý tại CH/CN</p>
                </div>
                <div>
                  {dataPrint?.processingMethod === "XLTN" ? (
                    <IconCheckbox size={14} />
                  ) : (
                    <IconSquare size={14} />
                  )}
                  <p>Xử lý tại nhà</p>
                </div>
              </div>
            </>
          )}
          {viewPrint === "PNHL" && (
            <>
              <div className={style.infoForm}>
                <div>
                  <div>
                    <p>Mã phiếu tiếp nhận hàng lỗi:</p>
                    <p>{dataPrint?.errorNumber || ""}</p>
                  </div>
                  <div>
                    <p>Kho:</p>
                    <p>
                      {dataPrint?.branchName
                        ? dataPrint?.brachName
                        : dataPrint.nameBranch}
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <p>Mã phiếu tiếp nhận yêu cầu:</p>
                    <p>{dataPYCXL?.requestNum}</p>
                  </div>
                  <div>
                    <p>Ngày nhận:</p>
                    <p>
                      {String(
                        new Date(dataPrint?.createDate).getHours(),
                      ).padStart(2, "0")}
                      :
                      {String(
                        new Date(dataPrint?.createDate).getMinutes(),
                      ).padStart(2, "0")}{" "}
                      {String(
                        new Date(dataPrint?.createDate).getDate(),
                      ).padStart(2, "0")}
                      /
                      {String(
                        new Date(dataPrint?.createDate).getMonth() + 1,
                      ).padStart(2, "0")}
                      /{new Date(dataPrint?.createDate).getFullYear()}
                    </p>
                  </div>
                </div>
              </div>
              <div style={{ paddingTop: "25px" }}></div>
            </>
          )}
        </div>
        <h4 className={style.titleCust}>Thông tin khách hàng</h4>
        <div className={style.mtt30}>
          <div className={style.nameAndPhone}>
            <div className={style.flexGap5}>
              <p className={style.fw}>Khách hàng hẹn gặp:</p>
              <p>{dataPrint?.custMeeting}</p>
            </div>
            <div className={style.flexGap5}>
              <p className={style.fw}>Số điện thoại:</p>
              <p>{dataPrint?.custPhone}</p>
            </div>
          </div>
          <div className={`${style.flexGap5} ${style.mtt25}`}>
            <p className={style.fw}>Địa chỉ:</p>
            {viewPrint === "PNHL" && (
              <p>
                {[dataPYCXL?.additionalAddress, dataPYCXL?.meetingAddress]
                  .filter((i) => i && String(i).length > 0)
                  .join(" - ")}
              </p>
            )}
            {viewPrint === "PYCXL" && (
              <p>
                {[dataPrint?.additionalAddress, dataPrint?.meetingAddress]
                  .filter((i) => i && String(i).length > 0)
                  .join(" - ")}
              </p>
            )}
          </div>
        </div>
        <h4 className={style.titleItem}>Thông tin sản phẩm</h4>
        <table className={`${style.table}`}>
          <thead>
            <tr>
              <th>Serial</th>
              <th>Tên sản phẩm</th>
              <th>Mã sản phẩm</th>
              <th>Đơn vị tính</th>
              <th>Thời hạn bảo hành</th>
              <th>Tình trạng ban đầu</th>
              <th>Loại dịch vụ</th>
            </tr>
          </thead>
          <tbody>
            {viewPrint === "PNHL"
              ? listDataViewPNHL?.map((item: any, index: any) => (
                  <tr key={index}>
                    <td>{item.serial}</td>
                    <td>{item.itemName}</td>
                    <td>{item.itemCode}</td>
                    <td>{item.uomName}</td>
                    <td>{item.warrantyTerm} tháng</td>
                    <td>{item.listErrorCode}</td>
                    <td>{item.serviceType}</td>
                  </tr>
                ))
              : dataPrint?.tblWarrantyServiceRequestFormDetailModels?.map(
                  (item: any, index: any) => (
                    <tr key={index}>
                      <td>{item.serial}</td>
                      <td>{item.itemName}</td>
                      <td>{item.itemCode}</td>
                      <td>{item.uomName}</td>
                      <td>{item.warrantyTerm} tháng</td>
                      <td>{item.listErrorCode}</td>
                      <td>{item.serviceType}</td>
                    </tr>
                  ),
                )}
          </tbody>
        </table>
        <div className={style.info}>
          <p className={style.fw}>II. Kiểm tra hoạt động của thiết bị</p>
          <div className={`${style.flexGap5} ${style.mtt25}`}>
            <p className={style.fw}>1. Tình trạng hoạt động:</p>
            <p>{dataPrint?.content}</p>
          </div>
          <div className={`${style.flexGap5} ${style.mtt25}`}>
            <p className={style.fw}>
              2. Dữ liệu, phần mềm, thiết lập cài đặt trong sản phẩm:
            </p>
            <p>Không có</p>
          </div>
        </div>
        <div className={`${style.info} ${style.mtt25}`}>
          <p className={style.fw}>
            III. Lưu ý quan trọng miễn trừ trách nhiệm:
          </p>
          <div className={`${style.inline} ${style.mtt10}`}>
            <p className={style.fw}>
              ✔ Trước khi gửi Sản phẩm cho HACOM kiểm tra, bảo hành
            </p>{" "}
            <p>
              quý khách vui lòng chuyển toàn bộ dữ liệu, ứng dụng phần mềm, cài
              đặt,… sang
            </p>{" "}
            <p className={style.fw}>thiết bị khác</p>{" "}
            <p>tránh mất/ thất thoát dữ liệu {"("}HACOM</p>{" "}
            <p className={style.fw}>không</p>{" "}
            <p>
              chịu trách nhiệm trong mọi trường hợp về dữ liệu, phần mềm chuyên
              dụng và các thiết lập, cài đặt và tính hợp pháp của phần mềm có
              trong sản phẩm của khách hàng
              {")"}.
            </p>
          </div>
          <div className={style.inline}>
            <span>
              ✔ HACOM/Nhà Cung Cấp/Hãng sẽ reset và xóa toàn bộ dữ liệu, thiết
              lập, cài đặt trên sản phẩm để kiểm tra sản phẩm, xác định nguyên
              nhân lỗi. Chính vì vậy tất cả các dữ liệu và thiết lập, cài đặt
              trên sản phẩm đều bị xóa hết và không thể phục hồi.
            </span>
          </div>
          <div className={style.inline}>
            <span>
              ✔ Biên bản này được lập thành 2 bản, Khách hàng và HACOM mỗi bên
              giữ một bản và có giá trị như nhau.
            </span>
          </div>
          <div className={style.inline}>
            <span>
              ✔ Quý khách khi nhận lại sản phẩm phải có biên bản này. Mọi chi
              tiết xin liên hệ 19001903 phím 3.
            </span>
          </div>
        </div>
        <div className={style.signature}>
          <div>
            <p className={style.fw}>Khách hàng gửi</p>
            <p className={style.italic}>(Ký và ghi rõ họ tên)</p>
            <p className={`${style.fw} ${style.italic}`}>Đã sao lưu dữ liệu</p>
          </div>
          <div>
            <p className={style.fw}>Kỹ thuật kiểm tra</p>
            <p className={style.italic}>(Ký và ghi rõ họ tên)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoodsReceiptInspectionRecord;
